import { render } from "./computerglass.vue?vue&type=template&id=130ef1ab"
import script from "./computerglass.vue?vue&type=script&lang=js"
export * from "./computerglass.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__